import { onDocumentReady } from "@story/story_assets/utils";

; (function() {

	// *************************************************************************
	// Přilepovací horní část menu.
	// Požadavek na přilepovací menu přišel později, když už byla hlavička hotová
	// a bylo jednodušší vytvořit novou hlavičku, která se zobrazuje/skrývá na základě
	// skriptu níže. Druhá alternativa, která by v prohlížečích využívala position sticky,
	// by byla v tuto chvíli komplikovanější na implementaci.
	// *************************************************************************

	// Je přilepovací hlavička povolena? Jsou případy, kdy ji nechceme zobrazovat a nebo napak,
	// kdy ji chceme mít přilepenou za všech okolností. Možnosti jsou: enabled, forced a disabled.
	var state = "enabled";

	// Offset (resp. odscrollovaná vzdálenost, kdy se má přilepovací hlavička zobrazit) zadáváme v jednotkách rem,
	// protože web se nám s breakpointy mění (využíváme proměnlivosti rem jednotky).
	var OFFSET = 14; // [rem]

	// Nechceme neustále počítat velikost "rem" jednotky, proto stanovíme hranici v pixelech,
	// za níž už je jasné, že se hlavička zobrazit má.
	var ACCURACY_THRESHOLD = (OFFSET + 1) * 16; // [px]

	// Kontejner s hlavičkou.
	var headerElement = null;

	//
	// Javascript počítá pouze v pixelech, my ale máme dokument v jednotkách rem. Tato funkce
	// spočte převodní koeficient z rem jednotek na pixely.
	//
	function computeRemToPxRatio() {
		return parseFloat(getComputedStyle(document.documentElement).fontSize);
	}

	//
	// Konverze rem jednotky na pixely.
	//
	function remToPx(rem) {
		return rem * computeRemToPxRatio();
	}

	//
	// Samotné rozhodnutí, jestli je odscrollaná dostatečná vzdálenost (porovnáme v rámci rychlosti na
	// hranici v pixelech a když jsme kdesi na začátku, tak provedeme výkonově pomalejší, ale přesnější porovnání
	// přes rem jednotky).
	//
	function stickyScroll() {
		if (!headerElement) {
			return;
		}

		var isSticky = state == "forced";

		if (state == "enabled") {
			var scrollPosition = window.scrollY;

			// Přilepení hlavičky z hlediska scroll pozice.
			isSticky = ACCURACY_THRESHOLD < scrollPosition || remToPx(OFFSET) < scrollPosition;
		}

		headerElement.classList[isSticky ? "add" : "remove"]("sticky"); // IE11 nezná druhý argument pro toggle, musíme proto přidání/odebrání třídy zajistit tímto způsobem.
	}

	//
	// Propojíme hlavičku se skriptem. Zatím se používá pouze na přilepovací hlavičku,
	// tak neděláme žádná jiná extra kouzla.
	//
	onDocumentReady(function() {
		headerElement = document.querySelector(".page-sticky-header");
		if (!headerElement) {
			return;
		}

		// První zavolání.
		stickyScroll();

		// Napojení na událost.
		window.addEventListener("scroll", stickyScroll, { passive: true });
	});

	window.StickyHeader = {
		scroll: stickyScroll,
		enable: function() { state = "enabled"; stickyScroll(); },
		force: function() { state = "forced"; stickyScroll(); },
		disable: function() { state = "disabled"; stickyScroll(); }
	};

}());